import wssEventNotifier from '../wss/WssEventNotifier';
import EngineCleanupBase from './EngineCleanupBase';

export default class WssEventHandlerBase extends EngineCleanupBase {
    _name = 'WssEventHandlerBase';

    _wsNotifier = wssEventNotifier;

    bootup() {
        this.initialize(this._name);
    }

    cleanup() {
        super.clear();
    }
}
